module.exports = __webpack_public_path__ + "static/ecommerce-mobile-2d23b014ca7f5b53531afea66b989eb5.png";